import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  allInclusive: {
    text: string | null | undefined;
  };
  fidelity: {
    text: string;
  };
  spreadPayment: {
    number: string;
    text: string;
  };
  type: 'summer' | 'winter';
};
const IMAGE_URLS = {
  summer: {
    className: "bg-[url('https://assets.dream.clubmed/pm_7531_772_772587-4bhfwl77ek-swhr.jpg')]",
    position: '50% -430px',
  },
  winter: {
    className: "bg-[url('https://assets.dream.clubmed/pm_7531_554_554209-cir0irc6yx-swhr.jpg')]",
    position: '50% -100px',
  },
};
export const CandyBar = ({ allInclusive, fidelity, spreadPayment, type }: Props) => {
  return (
    <div
      className={classnames(
        'flex h-[572px] flex-col items-center rounded-12 bg-cover bg-no-repeat text-center font-sans font-bold text-white text-shadow-1 sm:flex-row md:h-170',
        IMAGE_URLS[type].className,
      )}
      style={{ backgroundPosition: IMAGE_URLS[type].position }}
    >
      <div className="flex flex-col items-center justify-around py-20 sm:w-7/10 sm:flex-row sm:items-end">
        {spreadPayment.number ? (
          <div className="w-2/3 py-15 sm:w-auto sm:px-20">
            <div>
              <span className="font-brand text-60 font-normal leading-1">
                {spreadPayment.number}
              </span>
              <span className="font-brand text-40 font-normal leading-1">&times;</span>
            </div>
            <div className="w-full">
              <TemplateString
                template={spreadPayment.text}
                values={{
                  number: spreadPayment.number,
                }}
              />
            </div>
          </div>
        ) : null}
        <div className="relative w-2/3 py-15 sm:w-auto sm:px-20">
          <Icon
            className="mb-10"
            isNotSquare
            name={ICONS.CLUBMED_GREAT_MEMBERS_WITH_SHADOW}
            width="6.875rem"
          />
          <div className="w-full">{fidelity.text}</div>
        </div>
        {allInclusive.text ? (
          <div className="w-2/3 py-15 sm:w-auto sm:px-20">
            <Icon className="mb-10" name={ICONS.ALL_INCLUSIVE_WITH_SHADOW} width="2.6875rem" />
            <div className="w-full">{allInclusive.text}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
